import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, DestroyRef, ElementRef, HostListener, inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDrawer } from '@angular/material/sidenav';

import { Router } from '@angular/router';
import { UserModel } from 'countable@model';
import { FsExportService } from 'countable@services';
import { ToastrService } from 'ngx-toastr';
import { ResizeModel } from 'src/app/model/eng/resize.model';
import { AclModel } from '../../../model/acl.model';
import { AclService } from '../../../services/acl.service';
import { AuthService } from '../../../services/auth.service';
import { EngApiService } from '../../../services/eng-api.service';
import { WorkbookService } from '../../../services/workbook.service';
import { ApiService } from './../../../services/api.service';
import { SharedService } from './../../shared/shared.service';

@Component({
  selector: 'app-trail-balance-working-sheet',
  templateUrl: './trail-balance-working-sheet.component.html',
  styleUrls: ['./trail-balance-working-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class TrailBalanceWorkingSheetComponent implements OnInit {
  @ViewChild('centerSection', {static: false}) centerSection!: ElementRef;
  @ViewChild('leftPanel', {static: false}) leftPanel!: ElementRef;
  @ViewChild('togglePanel', {static: false}) togglePanel!: ElementRef;
  @ViewChild('drawer') drawer!: MatDrawer;

  engagementData: any;
  engagementName: any;
  clientName: any;
  yearEnd: any;
  isSideMenuExpanded: boolean = true;
  isPreviewPanelExpanded: boolean = false;
  selectedEngagementDataCopy: any;
  engfinsettingid: any;
  isyesno: any;
  engagementID: any;
  ntrMenuData: any;
  compilationType: string;
  typeOfEntityId: number;
  hideRightSidePanel: boolean = false;
  workBookLeftSideMenu: any = [];
  isEditableMenu: boolean = false;
  subModuleId: any;
  isOldSubModuleName: string = '';
  user: UserModel;
  shortCutMenuDetails: any;
  acl: AclModel;
  private destroyRef = inject(DestroyRef);

  @HostListener('window:storage', ['$event'])
  onStorageChange(ev: StorageEvent) {
    if (ev.key == 'RetainedEarningStatement') {
      this.getWBLeftSideMenu(true, true);
    }
    if (ev.key == 'adjustmentEntrySaved') {
      this.getWBLeftSideMenu(false);
    }
    if (ev.key == 'RetainedEarningStatement') {
    this.isyesno = parseInt(localStorage.getItem('isyesno'));
    this.getNtrMenuData();
    }
    if(ev.key ==='refreshWorkbookPreview' && ev.newValue) {
      this.fsService.removeAllFsDocs();
      this.shareService.clearAllRefreshValues();
      const refreshMap = this.shareService.refreshWorkbookPreview(this.router.url);
      this.shareService.updateFinStatement$.next(refreshMap);
      localStorage.removeItem('refreshWorkbookPreview');
    }
  }

  // Method to handle clicks outside
  @HostListener('document:click', ['$event.target'])
  @HostListener('document:touchstart', ['$event.target'])
  onClickOutside(target: HTMLElement): void {
    const isInside = this.centerSection.nativeElement.contains(target);
    const isLeftPanel = this.leftPanel.nativeElement.contains(target);
    const isTogglePanel = this.togglePanel.nativeElement.contains(target);
    if (window.innerWidth < 991 && isInside && !isLeftPanel && !isTogglePanel) {
      this.drawer.close();
    }
  }

  constructor(private authService: AuthService, private aclService: AclService, public router: Router,
              private apiService: ApiService, public shareService: SharedService, 
              public toaster: ToastrService, private fsService: FsExportService, private engApiService: EngApiService,
              private wbService: WorkbookService) {
  }

  ngOnInit() {
    this.authService.subjectUser.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(user => {
      this.user = user;
    });
    this.aclService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(acl => {
      this.acl = acl;
    });
    this.shareService.updateFInancialSettings.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.getWBLeftSideMenu(true);
    })
    this.shareService.refreshWorkbookmenu.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if(res === true){
        this.getWBLeftSideMenu(false);
      }
    });
    this.engagementData = JSON.parse(localStorage.getItem("selectedEngagementObj"));
    localStorage.setItem('isWorkBook','true');
    this.selectedEngagementDataCopy = JSON.parse((localStorage.getItem('selectedEngagementObjCopy')));
    this.shortCutMenuDetails = JSON.parse(localStorage.getItem('shortCutMenuDetails'));
    this.engagementName = this.selectedEngagementDataCopy.engagementName;
    this.engagementID = localStorage.getItem('engagementID');
    this.clientName = this.selectedEngagementDataCopy.clientName;
    this.yearEnd = this.selectedEngagementDataCopy.yearEnd;
    this.compilationType = this.selectedEngagementDataCopy.compilationtype;
    this.typeOfEntityId = this.selectedEngagementDataCopy.typeOfEntityId;
    this.getWBLeftSideMenu(false);
    this.getNtrMenuData();
    this.shareService.partnersCapitalView.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      this.hideRightSidePanel = response;
    });
    this.shareService.closePreview.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => this.isPreviewPanelExpanded = response);
    this.shareService.refreshWindow.next(window);
  }

  sideMenutoggleDrawer() {
    this.isSideMenuExpanded = !this.isSideMenuExpanded;
    this.shareService.sortingPosition.next(this.isSideMenuExpanded);
  }

  previewToggleDrawer() {
    this.isPreviewPanelExpanded = !this.isPreviewPanelExpanded;
    localStorage.setItem('isWorkBook','true');
  }

  getWBLeftSideMenu(isShowSpinner: boolean, isRefrshMenu?: boolean) {
    this.workBookLeftSideMenu = [];
    this.wbService.getWbLeftSide(this.engagementID).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.workBookLeftSideMenu = JSON.parse(res?.data);
          this.workBookLeftSideMenu.forEach(routingName => {
            if (routingName.uirouting === 'tb-ls-grouping') {
              routingName.routeUrl = '/trial-balance-working-sheet/tb-ls-grouping';
            } else if (routingName.uirouting === 'balancesheet') {
              routingName.routeUrl = '/trial-balance-working-sheet/balance-sheet';
            } else if (routingName.uirouting === 'incomeloss') {
              routingName.routeUrl = '/trial-balance-working-sheet/income-statement';
            } else if (routingName.uirouting === 'partnercapital') {
              routingName.routeUrl = '/trial-balance-working-sheet/partners-capital';
            } else if (routingName.uirouting === 'retainedearning') {
              routingName.routeUrl = '/trial-balance-working-sheet/retained-earnings';
            } else if (routingName.uirouting === 'notestofs') {
              routingName.routeUrl = '/trial-balance-working-sheet/fs-notes';
            } else if (routingName.uirouting === 'stockholdersequity') {
              routingName.routeUrl = '/trial-balance-working-sheet/Stockholdersequity';
            } else if (routingName.uirouting === 'cashflow') {
              routingName.routeUrl = '/trial-balance-working-sheet/cashflow';
            }
          });
        }
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  isMenuEditable(data) {
    if (this.shareService.isFirmTemplatesNotesEditoropened) {
      this.toaster.error('Please save/cancel changes made to the note before proceeding');
    }
    else {
      this.isEditableMenu = true;
      this.subModuleId = data.submoduleid;
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    let count = 0;
    let data = [];
    moveItemInArray(this.workBookLeftSideMenu, event.previousIndex, event.currentIndex);

    this.workBookLeftSideMenu.forEach(element => {
      count = count + 1;
      data.push({
        "submoduleid": element.submoduleid,
        "engagementsid": this.engagementID,
        "ordernumber": count,
      });
    });

    let inputParameters = JSON.stringify({
      'order': data
    });

    this.wbService.saveOrderChange(inputParameters).subscribe({
      next: res => {
        this.isEditableMenu = false;
        this.getWBLeftSideMenu(true);
        this.toaster.success('Workbook menu reorder successfully');
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  viewPage(routingName) {
    localStorage.setItem('WUUID', routingName.subModuleUUID);
    if (routingName.uirouting === 'tb-ls-grouping') {
      localStorage.setItem('workBookSubmoduleId', routingName.submoduleid);
      this.router.navigate(['/trial-balance-working-sheet/tb-ls-grouping']);
    } else if (routingName.uirouting === 'balancesheet') {
      localStorage.setItem('workBookSubmoduleId', routingName.submoduleid);
      this.router.navigate(['/trial-balance-working-sheet/balance-sheet']);
      localStorage.setItem('isWorkBook','true');
    } else if (routingName.uirouting === 'notestofs') {
      localStorage.setItem('workBookSubmoduleId', routingName.submoduleid);
      this.router.navigate(['/trial-balance-working-sheet/fs-notes']);
    }else if (routingName.uirouting === 'incomeloss') {
      localStorage.setItem('workBookSubmoduleId', routingName.submoduleid);
      this.router.navigate(['/trial-balance-working-sheet/income-statement']);
      localStorage.setItem('isWorkBook','true');
    } else if (routingName.uirouting === 'partnercapital') {
      localStorage.setItem('workBookSubmoduleId', routingName.submoduleid);
      this.router.navigate(['/trial-balance-working-sheet/partners-capital']);
    } else if (routingName.uirouting === 'retainedearning') {
      localStorage.setItem('workBookSubmoduleId', routingName.submoduleid);
      this.router.navigate(['/trial-balance-working-sheet/retained-earnings']);
      localStorage.setItem('isWorkBook','true');
    }else if (routingName.uirouting === 'cashflow') {
      localStorage.setItem('workBookSubmoduleId', routingName.submoduleid);
      this.router.navigate(['/trial-balance-working-sheet/cashflow']);
      localStorage.setItem('isWorkBook','true');
    }
    else if (routingName.uirouting === 'stockholdersequity') {
      localStorage.setItem('workBookSubmoduleId', routingName.submoduleid);
      this.router.navigate(['/trial-balance-working-sheet/Stockholdersequity']);
    }
    this.closeLeftPanel();
  }

  saveLeftSideMenuName(data) {
    const saveLeftMenu = JSON.stringify({
      'submoduleid': data.submoduleid,
      'engagementsid': this.engagementID,
      'submodulename': data.submodulename,
      'Originalname': this.isOldSubModuleName
    });

    this.wbService.saveWbLeftSideNameChange(saveLeftMenu).subscribe({
      next: res => {
        this.isEditableMenu = false;
        this.getWBLeftSideMenu(true);
        this.toaster.success('Name saved successfully');
        this.shareService.leftSideMenuNameChange.next(true);
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  getNtrMenuData() {
    this.engApiService.getEngSetting(this.engagementID).subscribe({
      next: res => {
        localStorage.removeItem('RetainedEarningStatement');
        var data = JSON.parse(res);
        data[0].Financial.forEach(element => {
          if (element.engfinsettingid === 2) {
            this.engfinsettingid = 2;
            this.isyesno = element.isyesno;
          }
        });
      }
    })
  }

  closeLeftPanel() {
    if(window.innerWidth < 991){
      this.drawer.close();
    }
  }

  public onResizePanelEnd(resizeData: ResizeModel) {
    resizeData.width < resizeData.minWidth ? this.drawer.close() : '';
  }

}
